import { create } from 'zustand';
import { VariantPackCostChange } from '@sales-portal/domain/pricing/screens/management/blocs/transformers/use-pricing-management-transformers';

export enum PricingCatalogSearchMode {
  CatalogEmpty = 'catalog_empty',
  CatalogError = 'catalog_error',
  CatalogResults = 'catalog_results',
  CatalogSearching = 'catalog_searching',
  Og = 'og',
}

interface PricingCatalogSearchState {
  error: Error | null;
  mode: PricingCatalogSearchMode;
  results: VariantPackCostChange[];
  searchTerm: string;
}

interface PricingCatalogSearchActions {
  onCatalogSearch: (term: string) => void;
  onCatalogSearchError: (error: Error) => void;
  onCatalogSearchResults: (results: VariantPackCostChange[]) => void;
  onExitCatalogMode: () => void;
}

type PricingCatalogSearchStore = PricingCatalogSearchState &
  PricingCatalogSearchActions;

const initialState: PricingCatalogSearchState = {
  error: null,
  mode: PricingCatalogSearchMode.Og,
  results: [],
  searchTerm: '',
};

export const selectIsCatalogMode = (
  state: PricingCatalogSearchState,
): boolean => state.mode !== PricingCatalogSearchMode.Og;

export const selectIsCatalogLoading = (
  state: PricingCatalogSearchState,
): boolean => state.mode === PricingCatalogSearchMode.CatalogSearching;

export const usePricingCatalogSearchStore = create<PricingCatalogSearchStore>(
  (set) => ({
    ...initialState,

    onCatalogSearch: (term: string) => {
      set({
        error: null,
        mode: PricingCatalogSearchMode.CatalogSearching,
        searchTerm: term,
      });
    },

    onCatalogSearchError: (error: Error) => {
      set({ error, mode: PricingCatalogSearchMode.CatalogError });
    },

    onCatalogSearchResults: (results: VariantPackCostChange[]) => {
      set({
        error: null,
        mode:
          results.length > 0
            ? PricingCatalogSearchMode.CatalogResults
            : PricingCatalogSearchMode.CatalogEmpty,
        results,
      });
    },

    onExitCatalogMode: () => set(initialState),
  }),
);
